var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg2 = function Svg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 71,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#2_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M7.804 32.066 7.812 2H69v39.97H17.94m-3.833-29.554h25.977m-25.977 6.351h25.977m1.928 9.418h19.174m-19.174 6.351h19.174M3.938 69 2 57.403l26.725.062L30.787 69M7.947 33.066 19.65 22.381c3.21-.099 3.565 6.794 1.56 8.704l-4.61 4.386c2.934 5.267 1.551 6.41-1.692 10.875m-8.99 9.6L2.141 34.602c-.655-5.33.979-10.867 5.106-13.815m20.25 21.602c.257 2.729.025 4.22-2.073 5.781-1.913 1.424-2.888 2.858-2.627 4.772.174 1.276.588 2.536.915 4.378M53.789 9.558h7.807v9.37H53.79z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__a",
    x1: 35.5,
    x2: 35.5,
    y1: 2,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })))));
};
export default Svg2;